import { useState } from 'react';
import { useApp } from '../../context/AppContext';

function Step4() {
  const { state, dispatch } = useApp();
  const { appData } = state;
  const [platforms, setPlatforms] = useState(appData.platforms || []);

  const handlePlatformChange = (platform) => {
    if (platforms.includes(platform)) {
      setPlatforms(platforms.filter(p => p !== platform));
    } else {
      setPlatforms([...platforms, platform]);
    }
  };

  const handleNext = () => {
    dispatch({ 
      type: 'UPDATE_APP_DATA', 
      payload: { platforms } 
    });
    
    // Calcular valor baseado nas plataformas selecionadas
    let platformCost = 0;
    if (platforms.includes('android')) platformCost += 20;
    if (platforms.includes('ios')) platformCost += 20;
    if (platforms.length === 2) platformCost = 40; // Desconto para ambas
    
    dispatch({ type: 'UPDATE_PRICE', payload: { platforms: platformCost } });
    dispatch({ type: 'NEXT_STEP' });
  };

  const handleBack = () => {
    dispatch({ type: 'PREV_STEP' });
  };

  return (
    <div className="bg-white p-8 rounded-2xl shadow-xl">
      <h2 className="text-3xl font-bold mb-8 text-gray-900">Plataformas</h2>
      
      <div className="space-y-6">
        <p className="text-gray-900 text-lg">Selecione as plataformas para as quais deseja desenvolver seu aplicativo:</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div 
            className={`border-2 rounded-xl p-6 cursor-pointer transition-all duration-200 ${
              platforms.includes('android') 
                ? 'border-gray-900 bg-gray-50 shadow-md' 
                : 'border-gray-200 hover:border-gray-400 hover:bg-gray-50'
            }`}
            onClick={() => handlePlatformChange('android')}
          >
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={platforms.includes('android')}
                onChange={() => handlePlatformChange('android')}
                className="h-5 w-5 text-gray-900 focus:ring-gray-500 border-gray-300 rounded"
              />
              <label className="ml-3 block text-lg font-medium text-gray-900 cursor-pointer">
                Android
              </label>
            </div>
            <p className="mt-3 text-sm text-gray-600">
              Seu aplicativo estará disponível na Google Play Store
            </p>
          </div>

          <div 
            className={`border-2 rounded-xl p-6 cursor-pointer transition-all duration-200 ${
              platforms.includes('ios') 
                ? 'border-gray-900 bg-gray-50 shadow-md' 
                : 'border-gray-200 hover:border-gray-400 hover:bg-gray-50'
            }`}
            onClick={() => handlePlatformChange('ios')}
          >
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={platforms.includes('ios')}
                onChange={() => handlePlatformChange('ios')}
                className="h-5 w-5 text-gray-900 focus:ring-gray-500 border-gray-300 rounded"
              />
              <label className="ml-3 block text-lg font-medium text-gray-900 cursor-pointer">
                iOS
              </label>
            </div>
            <p className="mt-3 text-sm text-gray-600">
              Seu aplicativo estará disponível na Apple App Store
            </p>
          </div>
        </div>

        <div className="bg-gray-50 border-l-4 border-gray-900 p-6 rounded-r-xl">
          <div className="flex">
            <div className="ml-3">
              <p className="text-base text-gray-900">
                <strong>Valor:</strong> R$ 20,00 por plataforma ou R$ 40,00 para ambas
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 flex justify-between">
        <button
          onClick={handleBack}
          className="bg-gray-100 text-gray-900 px-8 py-3 rounded-xl hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 font-medium transition-all duration-200"
        >
          Voltar
        </button>
        <button
          onClick={handleNext}
          disabled={platforms.length === 0}
          className="bg-gray-900 text-white px-8 py-3 rounded-xl hover:bg-black focus:outline-none focus:ring-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
        >
          Próximo
        </button>
      </div>
    </div>
  );
}

export default Step4;